export const FILTER_DRAWER_HEADER_TEXT = {
    TITLE: 'Filter',
    SUBTITLE: 'Choose conditions to filter campaigns. You can also save a filter for later use.',
    AVAILABLE_FILTERS: 'Available filters',
};

export const FILTER_DRAWER_HEADER_AUTO_TESTS_IDS = {
    SELECT_FILTERS: 'select-filters',
};
